import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms'; 
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { ContactService } from './contact.service';
import { CarouselComponent } from './carousel/carousel.component';
import { TestComponent } from './test/test.component';
//import { SendgridModule,  SendgridService  } from 'ngx-sendgrid';

@NgModule({
  declarations: [
    AppComponent,
    PortfolioComponent,
    HomeComponent,
    ContactComponent,
    AboutComponent,
    CarouselComponent,
    TestComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    //SendgridModule.forRoot({token:'jrb_website_email'})
  ],
  providers: [ContactService],
  bootstrap: [AppComponent]
})
export class AppModule { }
